import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useTranslation } from 'react-i18next';
import '@/components/content/PlaceSummary/PlaceSummary';
export default function Place({ location, withAddress = true, }) {
    const { t } = useTranslation();
    const materialsCount = location.locations.flatMap((l) => l.materials).length;
    return (_jsxs("locator-place-summary", { children: [_jsx("h4", { children: location.name }), withAddress && _jsx("p", { children: location.address }), _jsxs("dl", { children: [_jsx("dd", { children: location.distance.toFixed(2) }), _jsx("dt", { children: t('common.miles', {
                            count: location.distance,
                        }) }), _jsx("dd", { children: materialsCount }), _jsx("dt", { children: t('common.materialsAccepted', {
                            count: materialsCount,
                        }) })] })] }));
}
